import React from "react";
import _ from "lodash";
import { Box, BoxCloseView, BoxOpenView } from "./style";
import onClickOutside from "react-onclickoutside";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: false
    };
  }
  handleClickOutside = evt => {
    this.setState({
      status: false
    });
  };
  selectItem(e, value) {
    e.stopPropagation();
    this.props.input.onChange(value);
    this.setState({ status: false });
  }
  render() {
    const { status } = this.state;
    return (
      <Box
        onClick={() => {
          this.handleClickOutside();
        }}
      >
        <BoxCloseView
          status={status}
          type={this.props.input.value.type}
          hasIcon={this.props.input.value.icon}
          size={this.props.size}
          hasBorder={this.props.hasBorder}
          className={`area no-select ${this.props.disabled ? "disabled" : ""}`}
          onClick={e => {
            e.stopPropagation();
            if (!this.props.disabled) {
              this.setState({ status: !status });
            }
          }}
        >
          <div className="select-value">
            {typeof this.props.input.value === "object" ? (
              <div className="selected">
                <span className="select-box-item-icon">
                  <i className={this.props.input.value.icon} />
                </span>
                <span>{this.props.input.value.value}</span>
              </div>
            ) : (
              <div className="selected default">
                {this.props.label || "انتخاب کنید"}
              </div>
            )}
          </div>
          <i className="icon mapsa-down-arrow" />
        </BoxCloseView>
        <BoxOpenView status={status}>
          <ul className="options">
            {this.props.options.map(option => {
              if (!_.isEqual(this.props.input.value, option))
                return (
                  <li
                    key={option.key}
                    onClick={e => {
                      e.stopPropagation();
                      if (option.action !== undefined) {
                        this.setState({ status: false });
                        option.action(this.props.input.name);
                      } else {
                        this.selectItem(e, option);
                      }
                    }}
                  >
                    {option.value}
                  </li>
                );
            })}
          </ul>
        </BoxOpenView>
        {this.props.meta.error && this.props.meta.error !== "" && (
          <span className="notice">{this.props.meta.error}</span>
        )}
      </Box>
    );
  }
}

export default onClickOutside(Index);
